import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { RejectedReason } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

export const rejectedReasonKeys = {
  [RejectedReason.NEVER_BILL]: 'approvals.approve_charges.rejected_reasons.never_bill',
  [RejectedReason.NOT_APPLIED]: 'approvals.approve_charges.rejected_reasons.not_applied',
} satisfies Record<RejectedReason, string>;

interface RejectedChipProps {
  reason?: RejectedReason | null;
}

export default function RejectedChip({ reason = null }: RejectedChipProps) {
  return (
    <Tooltip
      title={
        reason
          ? t('approvals.approve_charges.rejected_because', {
              reason: t(rejectedReasonKeys[reason]),
            })
          : ''
      }
    >
      <Typography
        component="span"
        data-test-id="rejected-chip"
        sx={(theme) => ({
          border: `solid 1px ${theme.palette.error.main}`,
          borderRadius: 0.5,
          color: theme.palette.error.main,
          display: 'inline-block',
          fontSize: '12px',
          fontWeight: 600,
          px: 0.75,
        })}
      >
        {t('approvals.approve_charges.rejected')}
      </Typography>
    </Tooltip>
  );
}
